import { useQuery } from '@tanstack/react-query';
import { locationsApi } from '../services/api';

export const useLocations = () => {
  return useQuery({
    queryKey: ['locations'],
    queryFn: locationsApi.getActive,
  });
};

export const useLocation = (id: string) => {
  return useQuery({
    queryKey: ['locations', id],
    queryFn: () => locationsApi.getById(id),
    enabled: !!id,
  });
};

// Get only customer-facing stores (locations that can sell to customers)
export const useStores = () => {
  return useQuery({
    queryKey: ['locations', 'stores'],
    queryFn: locationsApi.getStores,
  });
};

/** @deprecated Use useLocation instead */
export const useStore = (id: string) => {
  return useQuery({
    queryKey: ['locations', id],
    queryFn: () => locationsApi.getById(id),
    enabled: !!id,
  });
};
